import { I04CONCLIMCONS_State } from '@batical/types/src'

const I04CONCLIMCONS: I04CONCLIMCONS_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  dju_uuid: '2F384721-09DE-4B82-8582-FD35735868A8',
  in_nombreAnnee: 1.0,
  in_djureference: 2937,
  in_conso: [0],
  in_annee: [0],
  in_djus: [0],
  res_conso: [0],
  res_minConso: 0,
  res_maxConso: 10000,
  mode: 'none',
  calcul_code: 'I04CONCLIMCONS',
  line: [],
  line_conso: [],
  line_consoConstant: [],
  line_conso_web: []
}

export default I04CONCLIMCONS
